import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'child-cell',
  template: `
  <div class="flex align-items-center list-user-action">
  <a class="" href="javascript:void(0)" title="Add Services" (click)="invokeParentServiceAddMethod()">
      <i class="bx bx-wrench text-warning me-1 font-size-16"></i>
  </a>
  <a class="" href="javascript:void(0)" title="Edit" (click)="invokeParentEditMethod()">
      <i class="bx bx-edit text-success me-1 font-size-16"></i>
  </a>
  <ng-container *ngIf="apiEnabled">
      <a class="" href="javascript:void(0)" title="Account Management" (click)="invokeParentAccountManagementPage()">
          <i class="mdi mdi-account-cog text-info me-1 font-size-18"></i>
      </a>

      <a class="" href="javascript:void(0)" title="API Configuration" (click)="invokeParentAPIConfigurationPage()">
          <i class="mdi mdi-api text-dark me-1 font-size-18"></i>
      </a>
  </ng-container>

  <a class="" href="javascript:void(0)" title="Delete" (click)="invokeParentDeleteMethod()">
      <i class="bx bx-trash text-danger me-1 font-size-16"></i>
  </a>
</div>

  `,
  styles: [
    ``,
  ],
})
export class VendorActionsRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  apiEnabled = false;
  agInit(params: ICellRendererParams): void {
    this.params = params;
      if (this.params.data && this.params.data.apienabled === true) {
        this.apiEnabled = true;
      }
  }

  invokeParentAccountManagementPage() {
    this.params.context.componentParent.AccountManagementPageAction(this.params.data);
  }
  invokeParentAPIConfigurationPage() {
    this.params.context.componentParent.APIConfigurationPageAction(this.params.data);
  }
  public invokeParentEditMethod() {
    // this.params.context.componentParent.editService(
    //   `Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef?.headerName}`
    // );
    this.params.context.componentParent.editAction(this.params.node.data);
  }

  public invokeParentDeleteMethod() {
    this.params.context.componentParent.deleteAction(this.params.node.data);
  }

  public invokeParentServiceAddMethod() {
    this.params.context.componentParent.addServiceAction(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}